import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  idPrefix?: string;
}

export default function FaqAccordion({ items, idPrefix = "faq" }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const panelId = `${idPrefix}-panel-${index}`;
        return (
          <div
            key={item.q}
            className={`border rounded-lg overflow-hidden transition-colors ${
              isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100/60"
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                aria-controls={panelId}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={`text-lg ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div id={panelId} className="px-5 pb-5">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}